<template>
  <div>
    <div class="header_anniu" v-if="!nickname">
      <div class="header_anniu" v-if="router">
        <router-link class="header_login" tag="div" :to="{ path: '/login' }">{{ $t('nav_user.login') }}</router-link>
        <div class="header-xian">|</div>
        <router-link class="header_register" tag="div" :to="{ path: '/type' }">{{ $t('nav_user.register') }}</router-link>
      </div>

      <div class="header_i18n">
        <img style="width: 19px;height: 19px;margin-right: 10px;" src="@/img/i18n.png" alt="" />
        <div class=" CU">
          <a-dropdown v-model="langvisible">
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">{{ $t('nav_user.langtext') }} </a>
            <a-menu slot="overlay" style="margin-top: 20px;" @click="langClick">
              <a-menu-item key="zh">{{ $t('nav_user.languagezh') }}</a-menu-item>
              <a-menu-item key="en">{{ $t('nav_user.languageen') }}</a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </div>
    </div>

    <!-- 这个是登录成功后 -->
    <div class="header_anniu" v-else>
      <!--   <div class="header_URL CU">
        <img src="@/img/msg.png" class="header_img" alt="">
      </div> -->
      <router-link tag="div" class="header_user CU" to="/account_management">
        <a-dropdown v-model="visible">
          <a class="ant-dropdown-link" style="height: 100%;display: flex;align-items: center;" @click="routers($event)">{{ nickname }}</a>
          <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item key="1">{{ $t('nav_user.logout') }}</a-menu-item>
          </a-menu>
        </a-dropdown>
      </router-link>
      <div class="header_i18n">

        <div class=" CU">

          <a-dropdown v-model="langvisible">

            <a class="ant-dropdown-link" @click="e => e.preventDefault()"><img  style="width: 19px;height: 19px;margin-right: 10px;" src="@/img/i18n.png" alt="" /><span class="no_user">{{ $t('nav_user.langtext') }}</span></a>
            <a-menu slot="overlay" style="margin-top: 20px;" @click="langClick">
              <a-menu-item key="zh">{{ $t('nav_user.languagezh') }}</a-menu-item>
              <a-menu-item key="en">{{ $t('nav_user.languageen') }}</a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
export default {
  inject:['reload'],
  data() {
    return {
      langvisible: false,
      visible: false,
      router: true
    };
  },
  created() {
    // var router = ['/login', '/register'];
    // if (router.includes(this.$route.path)) {
    //   this.router = false;
    // } else {
    //   this.router = true;
    // }
  },
  watch: {
    // $route(to, from) {
    //   var router = ['/login', '/register'];
    //   if (router.includes(to.path)) {
    //     this.router = false;
    //   } else {
    //     this.router = true;
    //   }
    // }
  },
  methods: {
    ...mapActions('game',['clearVuexDataContent']),
    langClick(e) {
      if (localStorage.getItem('mp_lang') == e.key) {
        return;
      }
      localStorage.setItem('mp_lang', e.key);
      this.$i18n.locale = e.key;
      this.reload()

      // 把vuex 存储起来的数据清除
      this.clearVuexDataContent()


      // location.reload();

    },
    routers(e) {
      console.log(44445456);
      // e.preventDefault()
      this.$router.push({
        path: '/account_management'
      });
    },
    handleMenuClick(e) {
      this.visible = false;
      let lang = localStorage.getItem('mp_lang')
      localStorage.clear();
      localStorage.setItem('mp_lang',lang)
      this.$store.commit('user/setnickname', '');
      setTimeout(() => {
        this.$router.replace('/login');
      }, 100);
    }
  },
  computed: {
    ...mapState('user', ['nickname'])
  }
};
</script>

<style scoped="scoped">
.header_anniu {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.header-xian,
.header_login,
.header_register,
.header_i18n {
  color:  #2b3543;
  font-size: 14px;
  cursor: pointer;
}
.header-xian {
  margin: 0 10px;
}
.header_i18n {
  margin-left: 40px;
  display: flex;
  align-items: center;
}
.header_URL {
  width: 17px;
  height: 20px;
}
.header_img {
  width: 17px;
  height: 20px;
}
.header_user {
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 20px;
  font-size: 14px;
  color: #999999;
}
a {
  color: #2b3543;
}

@media screen and (max-width: 1500px) {

  .no_user{
    display: none;
  }

}

</style>



// WEBPACK FOOTER //
// src/views/nav_user.vue